import * as React from 'react'

import {
  ILocation,
  IVirtualEvent,
  ListItemProps,
} from '@watermarkchurch/location-map'
import {
  calculateDistanceText,
  renderAddress,
  renderMeetingTime,
  renderMeetingTZ,
} from '@watermarkchurch/location-map'

export const ListItem = (props: ListItemProps) => {
  const { hit } = props

  if (hit.isVirtual) {
    return <VirtualListItem {...props} hit={hit} />
  }

  return <InPersonListItem {...props} hit={hit} />
}

interface IInPersonListItemProps extends ListItemProps {
  hit: ILocation
}

const InPersonListItem: React.FunctionComponent<IInPersonListItemProps> = (props) => {
  const {hit, userLocation} = props
  return (
    <div className="churches-list__item__content">
      <h4 className="churches-list__item__content__title">
        { hit.title }
      </h4>

      <div className="churches-list__item__content__details">
        <span className="churches-list__item__content__text">
          {hit.address.city}, {hit.address.state}
        </span>
        &nbsp;
        {userLocation && <>
          <span className="churches-list__item__content__distance">
            {calculateDistanceText({
              ...props,
              userLocation
            })}
          </span>
          &nbsp;
        </>}
        <span className="churches-list__item__content__datetime">
          { renderMeetingTime(hit, props.translate) }
        </span>
      </div>
    </div>
  )
}

interface IVirtualListItemProps extends ListItemProps {
  hit: IVirtualEvent
}

const VirtualListItem: React.FunctionComponent<IVirtualListItemProps> = ({hit, translate}) => {
  const genderKey = hit.genders.length > 1 ? 'all' : hit.genders[0]

  const meetingTz = renderMeetingTZ(hit.meetingTimeZone, hit.next_occurrence && hit.next_occurrence.start_time_ts)

  return (
    <div className="churches-list__item__content">
      <h4 className="churches-list__item__content__title">
        { renderMeetingTime(hit, translate) } { meetingTz }
      </h4>

      <div>
        {hit.address && <span className="churches-list__item__content__text">
          { renderAddress(hit.address) }
        </span>}

        {hit.genders.length > 0 && <span className="churches-list__item__content__datetime">
          &nbsp;{ translate(['locationMap', 'meetingGender', genderKey]) }
        </span>}

        <span className="churches-list__item__content__account-name">
          {hit.title}
        </span>
      </div>
    </div>
  )
}
